import { render, staticRenderFns } from "./BasicViewForm.vue?vue&type=template&id=40b81d21&scoped=true"
import script from "./BasicViewForm.vue?vue&type=script&lang=js"
export * from "./BasicViewForm.vue?vue&type=script&lang=js"
import style0 from "./BasicViewForm.vue?vue&type=style&index=0&id=40b81d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b81d21",
  null
  
)

export default component.exports